import React from 'react';

const ML_Brain_js = () => {
    return (
        <div>ML_Brain_js Component</div>
    );
}

export default ML_Brain_js;
